/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_O2Inputs */

const en_mk_sol_konsultan_o2 = /** @type {(inputs: Mk_Sol_Konsultan_O2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every figure in a report has a trail you can show`)
};

const id_mk_sol_konsultan_o2 = /** @type {(inputs: Mk_Sol_Konsultan_O2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap angka di laporan punya jejak yang bisa ditunjukkan`)
};

/**
* | output |
* | --- |
* | "Every figure in a report has a trail you can show" |
*
* @param {Mk_Sol_Konsultan_O2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_o2 = /** @type {((inputs?: Mk_Sol_Konsultan_O2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_O2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_o2(inputs)
	return en_mk_sol_konsultan_o2(inputs)
});